module.exports = __webpack_public_path__ + "static/business-5ddd86bc6108e2106e277714724cc3a0.svg";